import get from 'lodash/get';
import Browser from '@wetransfer/concorde-browser';

import { AdUnitsService } from '../ad-units-service';
import { optimizePath } from '../../helpers/optimize-path';
import { wallpaperFormat } from '../../helpers/wallpaper-format';
import { getDuid } from '../../helpers/custom-events';

import { AppConfig } from '@app/core-bundle/config/app-config';

import request from '@module/http/axios/request';

export const AdblockerProvider = {
  get name() {
    return 'ADBLOCKER_PROVIDER';
  },

  domainUserId() {
    const cookieName = AppConfig.cookies.snowplow.name;
    return getDuid(cookieName);
  },

  isRotationEnabled() {
    return true;
  },

  rotationInterval(config, { wallpaper }) {
    const nextPosition = wallpaper.position + 1;

    // The rotation interval can be different based on the wallpaper position.
    // The higher the position, the longer the rotation interval.
    const interval = AdUnitsService.calculateInterval(nextPosition);

    return interval;
  },

  // Show editorial wallpapers when:
  // - an adBlocker has been detected,
  // - the request to Adzerk has been blocked
  test(config, { wallpaper }) {
    if (!config.isAdvertisingEnabled) return true;

    if (wallpaper.blockedByClient === true) return true;

    return false;
  },

  async nextCreative(config, { channel, user, wallpaper }) {
    const nextPosition = wallpaper.position + 1;
    const zoneId = AdUnitsService.calculateSlots(nextPosition)[0];
    const duid = this.domainUserId();

    const response = await request({
      path: config.editorialUrl,
      params: {
        duid,
        zoneId,
        utm_source: this.source(),
        utm_reason: this.reason(config, channel, user, wallpaper),
      },
    });

    return this.parseResponse(config, response.body);
  },

  parseResponse(config, response) {
    const src = response.src;

    return {
      src: optimizePath({ src: `${config.host}${src}` }),
      format: wallpaperFormat(src),
      meta: {
        href: get(response, 'meta.href', ''),
        title: get(response, 'meta.title', ''),
      },
    };
  },

  source() {
    return Browser.isMobile || Browser.isTablet ? 'mobile' : 'desktop';
  },

  // When using the Editorial Ads server, we want to know the reason why we are doing this.
  // We also want 'plus' to take precedence over 'adblocker' or 'privacy' as we don't want
  // to ask Pro users that haven't set up a background yet to disable their ad blocker.
  reason(config, channel, user, wallpaper) {
    if (!config.isAdvertisingEnabled) return 'adblocker';

    if (wallpaper.blockedByClient === true) return 'privacy';

    return null;
  },
};
